export default __webpack_public_path__ + "static/media/kwadrat_kato.09f20b07.jpg";